import React, { Suspense, useEffect, useRef, useState } from "react";
import { Heading, Img, Button, Text } from "../../components";
import axios from "axios";
import { API_DOMAIN_IMG, API_DOMAIN } from "config";

const STEP = 1000;
const DOCUMENT_FILTERS = {
  license: "מידע משרד התחבורה",
  priceList: "מחיר לוי יצחק",
  partsList: "חלקי חילוף",
};
const AUCTION_FILTERS = {  
  future: "רכבים במכרז עתידי",
  active: "רכבים במכרז פעיל",
};

function MultiSelectDropdown({ label, options, selected, setSelected, showSearch = true }) {  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  const sortedOptions = [...options].sort((a, b) => a.localeCompare(b, "he"));
  const filtered = sortedOptions.filter((opt) =>
    opt.toLowerCase().includes(search.toLowerCase())
  );

  const toggleOption = (option) => {
    setSelected((prev) =>
      prev.includes(option) ? prev.filter((item) => item !== option) : [...prev, option]
    );
  };

  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [isOpen]);

  return (
    <div ref={dropdownRef} className="relative filter-checkbox max-md:w-full">
      <div
        className="flex items-center justify-between gap-2 border-l border-gray-200 px-4 py-2 cursor-pointer text-right select-none"
        onClick={() => { setIsOpen((v) => !v); if (isOpen) setSearch(""); }}
        style={{ paddingRight: "1rem" }}
      >
        <Img
          src="/images/img_frame_1261154419.svg"
          alt="arrow"
          className={`h-[8px] transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
        />
        <div
          dir="rtl"
          className="text-[16px] font-normal lg:text-[1vw] match-font flex-1 min-w-0 whitespace-nowrap overflow-hidden text-ellipsis"
        >
          {selected.length > 0 ? (
            <span className="text-[#CE0000] font-medium">{selected.join(", ")}</span>
          ) : (
            label
          )}
        </div>
        {selected.length > 0 && (
          <button
            type="button"
            className="text-[11px] bg-[#CE0000] text-white rounded-full w-5 h-5 flex items-center justify-center flex-shrink-0 hover:bg-red-800 transition-colors"
            onClick={(e) => { e.stopPropagation(); setSelected([]); }}
          >
            ✕
          </button>
        )}
      </div>

      {isOpen && (
        <div
          className="absolute top-full right-0 z-50 w-full bg-white border border-gray-200 rounded-xl shadow-2xl overflow-hidden"
          style={{ zIndex: 9999, background: 'white' }}
        >
          {/* Search input */}
      {showSearch && (
  <div className="p-2 border-b border-gray-100">
    <input
      type="text"
      dir="rtl"
      placeholder={`חפש ${label}...`}
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      onClick={(e) => e.stopPropagation()}
      autoFocus
      className="w-full px-3 py-1.5 text-sm border border-gray-200 rounded-lg outline-none focus:border-[#CE0000] transition-colors"
    />
  </div>
)}

          {/* Selected chips */}
          {selected.length > 0 && (
            <div
              className="flex flex-wrap gap-1 px-2 py-1.5 border-b border-gray-100 max-h-[72px] overflow-auto"
              dir="rtl"
            >
              {selected.map((s) => (
                <span
                  key={s}
                  className="inline-flex items-center gap-1 bg-red-50 text-[#CE0000] text-[11px] px-2 py-0.5 rounded-full border border-red-200"
                >
                  {s}
                  <button
                    type="button"
                    onClick={(e) => { e.stopPropagation(); toggleOption(s); }}
                    className="font-bold hover:text-red-800"
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
          )}

          {/* Options list */}
          <div className="max-h-[200px] overflow-auto" dir="rtl">
            {filtered.length === 0 ? (
              <div className="text-center text-gray-400 text-sm py-4">לא נמצאו תוצאות</div>
            ) : (
              filtered.map((option) => (
                <label
                  key={option}
                  className={`flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-red-50 transition-colors ${
                    selected.includes(option) ? "bg-red-50" : ""
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={selected.includes(option)}
                    onChange={() => toggleOption(option)}
                    className="accent-[#CE0000] w-4 h-4 flex-shrink-0"
                  />
                  <span className="text-sm flex-1">{option}</span>
                  {selected.includes(option) && (
                    <span className="text-[#CE0000] text-xs font-bold">✓</span>
                  )}
                </label>
              ))
            )}
          </div>

          {/* Footer: clear all */}
          {selected.length > 0 && (
            <div className="border-t border-gray-100 p-2">
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); setSelected([]); }}
                className="w-full text-sm text-gray-400 hover:text-[#CE0000] transition-colors py-1 rounded-lg hover:bg-red-50"
              >
                נקה הכל ({selected.length})
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default function FilterBar({ onChange }) {
  const carTypeOptions = ["פרטי", "מסחרי"];
  const accidentTypeOptions = ["קלה", "בינונית", "קשה"];

  const [priceMin, setPriceMin] = useState(1000);
  const [priceMax, setPriceMax] = useState(1000000);
  const [carTypes, setCarTypes] = useState([]);

  const [manufacturerOptions, setManufacturerOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);

  const [selectedManufacturers, setSelectedManufacturers] = useState([]);
  const [selectedModels, setSelectedModels] = useState([]);
  const [selectedYears, setSelectedYears] = useState([]);
  const [models, setModels] = useState([]);
  const [accidentTypes, setAccidentTypes] = useState([]);
  const [minPriceLimit, setMinPriceLimit] = useState(1000);
  const [maxPriceLimit, setMaxPriceLimit] = useState(1000000);
  const [auction, setAuction] = useState(false);
  const [rehabilitation, setRehabilitation] = useState(false);
  const [dismantle, setDismantle] = useState(false);
  const [selectedSaleTypes, setSelectedSaleTypes] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [selectedAuctionStatuses, setSelectedAuctionStatuses] = useState([]);

  const [saleTypeOptions, setSaleTypeOptions] = useState([]); // [{id,name},…]

  // ✅ FIX (מינימום שינוי): ניהול פתיחה/סגירה של הפילטר במובייל בתוך FilterBar + onClick לכפתור
  const [drawerOpen, setDrawerOpen] = useState(false);
  const barRef = useRef(null);

  const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

  const toggleDrawer = (e) => {
    if (!isMobile()) return;
    e.stopPropagation();
    setDrawerOpen((v) => !v);
  };

  useEffect(() => {
    if (!isMobile()) return;

    const closeOnOutside = (e) => {
      if (!barRef.current) return;
      if (!barRef.current.contains(e.target)) setDrawerOpen(false);
    };

    const handleResize = () => {
      if (!isMobile()) setDrawerOpen(false);
    };

    document.addEventListener("click", closeOnOutside);
    window.addEventListener("resize", handleResize);

    return () => {
      document.removeEventListener("click", closeOnOutside);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handlePriceMinChange = (e) => {
    const v = +e.target.value;
    setPriceMin(Math.min(v, priceMax - STEP));
  };

  const handlePriceMaxChange = (e) => {
    const v = +e.target.value;
    setPriceMax(Math.max(v, priceMin + STEP));
  };

  const toggleSaleType = (id) => {
    setSelectedSaleTypes((prev) => (prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id]));
  };

  const setAuctionStatuses = (updater) => {
    setSelectedAuctionStatuses((prev) => {
      const next = typeof updater === "function" ? updater(prev) : updater;
      return next;
    });
  };

  useEffect(() => {
    axios
      .get(`${API_DOMAIN}/car/getSaleTypes`)
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        setSaleTypeOptions(data);
      })
      .catch((err) => {
        console.error("שגיאה בשליפת סוגי מכירה:", err);
        setSaleTypeOptions([]);
      });
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const [mfs, mdl, yrs] = await Promise.all([
          axios.get(`${API_DOMAIN}/car/getAllManufucters`),
          axios.get(`${API_DOMAIN}/car/getAllModels`),
          axios.get(`${API_DOMAIN}/car/getAllYears`),
        ]);

        setManufacturerOptions(mfs.data.map((x) => x.name).sort((a, b) => a.localeCompare(b, "he")));
        setModelOptions(mdl.data.map((x) => x.name).sort((a, b) => a.localeCompare(b, "he")));
        setYearOptions(yrs.data.map(String).sort((a, b) => b - a));
      } catch (err) {
        console.error("שגיאה בשליפת נתוני סינון:", err);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API_DOMAIN}/car/getPriceRange`);
        const { min_price, max_price } = res.data || {};

        const rawMin = Number(min_price ?? 1000);
        const rawMax = Number(max_price ?? 1000000);

        const alignedMin = Math.floor(rawMin / STEP) * STEP;
        const alignedMax = Math.ceil(rawMax / STEP) * STEP;

        setMinPriceLimit(alignedMin);
        setMaxPriceLimit(alignedMax);

        setPriceMin(alignedMin);
        setPriceMax(alignedMax);
      } catch (err) {
        console.error("שגיאה בשליפת טווח מחירים:", err);
      }
    })();
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      onChange?.({
        priceMin: priceMin !== minPriceLimit ? priceMin : null,
        priceMax: priceMax !== maxPriceLimit ? priceMax : null,
        manufacturers: selectedManufacturers,
        models: selectedModels,
        years: selectedYears,
        carTypes,
        accidentTypes,
        saleTypes: selectedSaleTypes.map(Number),
        hasLicenseDoc: selectedDocuments.includes(DOCUMENT_FILTERS.license) ? 1 : null,
        hasPriceListDoc: selectedDocuments.includes(DOCUMENT_FILTERS.priceList) ? 1 : null,
        hasPartsListDoc: selectedDocuments.includes(DOCUMENT_FILTERS.partsList) ? 1 : null,
        auctionStatus: selectedAuctionStatuses
          .map((status) => Object.keys(AUCTION_FILTERS).find((key) => AUCTION_FILTERS[key] === status))
          .filter(Boolean)
          .join(",") || null,
      });
    }, 250);

    return () => clearTimeout(t);
  }, [
    priceMin,
    priceMax,
    selectedManufacturers,
    selectedModels,
    selectedYears,
    carTypes,
    accidentTypes,
    selectedSaleTypes,
    selectedDocuments,
    selectedAuctionStatuses,
    minPriceLimit,
    maxPriceLimit,
    onChange,
  ]);

  return (
    <div
      ref={barRef}
      className={`filter-bar w-full overflow-visible py-2 ${drawerOpen ? "open" : ""}`}
      data-testid="catalog-filters"
    >
<div
 className="flex items-center gap-2 rounded-full border border-gray-200 bg-white px-2 py-2 justify-between w-full
                max-md:flex-col max-md:items-stretch max-md:justify-start max-md:gap-3"
                style={{paddingRight:"0.5rem"}}>

        <Button
          className="filter-toggle-btn hide-desktop"
          type="button"
          onClick={toggleDrawer}
          data-testid="filter-toggle-btn-mobile"
          data-tour="catalog-filter-toggle-mobile"
        >
          <Img src="/images/filter-icon.svg" />
        </Button>

<Button
  className="filter-toggle-btn hide-mobile"
  type="button"
  onClick={toggleDrawer}
  data-testid="filter-toggle-btn-desktop"
  data-tour="catalog-filter-toggle-desktop"
>
  <div className="bg-[#CE0000] p-[17px] rounded-[50px]">
    <Img src="/images/white-filter.svg" />
  </div>
</Button>
<div className="flex flex-col items-center justify-center border-l border-gray-200 px-4 py-1 min-w-[200px]
                max-md:order-3 max-md:min-w-0 max-md:w-full">

          <Text className="text-[14px]">מחיר</Text>
          <div className="relative w-full">
            <input
              type="range"
              min={minPriceLimit}
              max={maxPriceLimit}
              step="1000"
              value={priceMin}
              onChange={handlePriceMinChange}
              className="w-full absolute h-1 appearance-none accent-gray-500 pointer-events-auto"
            />
            <input
              type="range"
              min={minPriceLimit}
              max={maxPriceLimit}
              step="1000"
              value={priceMax}
              onChange={handlePriceMaxChange}
              className="w-full absolute h-1 appearance-none pointer-events-auto"
            />
          </div>
          <div className="flex justify-between w-full text-[12px] mt-3">
            <span>₪{priceMax.toLocaleString()}</span>
            <span>₪{priceMin.toLocaleString()}</span>
          </div>
        </div>

        {/* Checkboxes */}
<div className="flex items-center gap-2 border-l border-gray-200 px-4 py-1 min-w-[200px]
                max-md:order-2">
          {saleTypeOptions.map(({ id, name }) => (
            <label key={id} className="checkbox-item">
              <input
                type="checkbox"
                checked={selectedSaleTypes?.includes(id)}
                onChange={() => toggleSaleType(id)}
              />
              <span className="custom-checkbox" />
              {name}
            </label>
          ))}

          <span className="order-to text-[14px] font-semibold">מיועד ל</span>
        </div>

        {/* Multi dropdowns */}
<div className="checkbox-filter flex max-md:order-1 max-md:flex-col-reverse min-w-0">          {/*  <MultiSelectDropdown label="סוג התאונה" options={accidentTypeOptions} selected={accidentTypes} setSelected={setAccidentTypes} />*/}
    <MultiSelectDropdown
  label="מסמכים"
  options={Object.values(DOCUMENT_FILTERS)}
  selected={selectedDocuments}
  setSelected={setSelectedDocuments}
  showSearch={false}
/>
    <MultiSelectDropdown
      label="מכרזים"
      options={Object.values(AUCTION_FILTERS)}
      selected={selectedAuctionStatuses}
      setSelected={setAuctionStatuses}
      showSearch={false}
    />
          <MultiSelectDropdown
            label="סוג הרכב"
            options={carTypeOptions}
            selected={carTypes}
            setSelected={setCarTypes}
          />

          <MultiSelectDropdown
            label="שנת יצור"
            options={yearOptions}
            selected={selectedYears}
            setSelected={setSelectedYears}
          />
          <MultiSelectDropdown
            label="דגמים"
            options={modelOptions}
            selected={selectedModels}
            setSelected={setSelectedModels}
          />
      
          <MultiSelectDropdown
            label="יצרנים"
            options={manufacturerOptions}
            selected={selectedManufacturers}
            setSelected={setSelectedManufacturers}
          />
        </div>
      </div>
    </div>
  );
}
